import { join } from 'juriquery'

import { Query } from '../types'

export const DOCUMENTS_FILLABLE_FORMS_ROOT_ROUTE = '/fillable-forms'
export const DOCUMENTS_FILLABLE_FORMS_CREATE_ROUTE = `${DOCUMENTS_FILLABLE_FORMS_ROOT_ROUTE}/create`
export const DOCUMENTS_FILLABLE_FORMS_EDIT_ROUTE = `:formId/edit`

export const getFillableFormsRoute = (query?: Query) =>
  join(DOCUMENTS_FILLABLE_FORMS_ROOT_ROUTE, query)

export const getFillableFormsCreateRoute = () =>
  DOCUMENTS_FILLABLE_FORMS_CREATE_ROUTE

export const getFillableFormsEditRoute = (formId: number) =>
  `${DOCUMENTS_FILLABLE_FORMS_ROOT_ROUTE}/${formId}/edit`
